var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvaMenuFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 63,
    viewBox: "0 0 71 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3146 28.875H11.6854C10.1333 28.875 8.875 29.9915 8.875 31.3687V31.6313C8.875 33.0085 10.1333 34.125 11.6854 34.125H59.3146C60.8667 34.125 62.125 33.0085 62.125 31.6313V31.3687C62.125 29.9915 60.8667 28.875 59.3146 28.875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3146 42H11.6854C10.1333 42 8.875 43.1165 8.875 44.4938V44.7562C8.875 46.1335 10.1333 47.25 11.6854 47.25H59.3146C60.8667 47.25 62.125 46.1335 62.125 44.7562V44.4938C62.125 43.1165 60.8667 42 59.3146 42Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3146 15.75H11.6854C10.1333 15.75 8.875 16.8665 8.875 18.2437V18.5063C8.875 19.8835 10.1333 21 11.6854 21H59.3146C60.8667 21 62.125 19.8835 62.125 18.5063V18.2437C62.125 16.8665 60.8667 15.75 59.3146 15.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaMenuFill);
export default __webpack_public_path__ + "static/media/eva_menu-fill.5ff3f19a226e2eaf2a42d152e03c5786.svg";
export { ForwardRef as ReactComponent };